export const NO_BENCHMARK = 'No Benchmark';
